import React from 'react';
import ReactDOM from 'react-dom';
import jsdk from '../../jsdk';
import micromd from '../../micromd';
import t from 'tcomb';
import { Component } from './Component';
import get_bundle from './get_bundle';
import Feedback from './Feedback';
import Behaviour from './Behaviour';
import UUID from './UUID';
import Natural from './Natural';
import Authorization from './Authorization';
import Confirm from '../components/Confirm'; // FIXME cosa ci fa qui?
import Alert from '../components/Alert'; // FIXME cosa ci fa qui?
import { template } from '../../template';

template.store('reducer_content', template(`
<div id="reducer_content" class="box light">
  <%= reducer %>
  <div class="large-text-center">
    <% if (is_skippable) { %>
    <button id="do_skip" class="big"><%= do_skip %></button>
    <% } %>
    <button id="do_reduce" <%= styleBtnColor %> class="big" ><%= do_reduce %></button>
    <%= required_privacy_form %>
    <div class="disclaimer">
      <small><%= standard_privacy_disclaimer %></small>
    </div>
    <% if (privacy_type !== "none") { %>
      <div id="privacy" class="<%= is_privacy_open ? "" : "large-hide " %>large-text-left"><%= privacy %></div>
    <% } %>
  </div>
</div>
`));

const Privacy_Type = t.enums.of([
  'none',
  'standard',
  'required'
], 'Privacy_Type');

const Reducer = t.struct({
  id: UUID,
  style: t.Object, //Reducer_Style,
  components: t.list(Component),
  privacy_type: Privacy_Type,
  privacy: t.maybe(t.String),  //ex markdown
  is_privacy_open: t.Boolean,
  is_skippable: t.maybe(t.Boolean),
  timeout: Natural,
  authorization: t.maybe(Authorization)
}, 'Reducer');

var likes = [];

Reducer.add_like = function (id: UUID) {
  likes.push(id);
};

Reducer.remove_like = function (id: UUID) {
  if (!id) {
    likes = [];
  }
  else {
    likes = likes.filter(function (like) {
      return like !== id;
    });
  }
};

Reducer.prototype.has_like = function (id: UUID) {
  return likes.some((like) => like === id);
};

var gpluses = [];

Reducer.add_gplus = function (id: UUID) {
  gpluses.push(id);
};

Reducer.remove_gplus = function (id: UUID) {
  if (!id) {
    gpluses = [];
  } else {
    gpluses = gpluses.filter(function (gplus) {
      return gplus !== id;
    });
  }
};

Reducer.has_gplus = function (id: UUID) {
  return gpluses.some((gplus) => gplus === id);
};

Reducer.prototype.get_privacy = function (default_privacy) {
  switch (this.privacy_type) {
    case 'none':
      return '';
    case 'standard':
    case 'required':
      return this.privacy || default_privacy || '';
  }
};

Reducer.prototype.getReducerForm = function (locale, like_url, gplus_url) {
  const config = {
    stacked: true,
    attrs: {
      id: this.id,
      style: this.style
    },
    rows: this.components.map(function (component: Component) {
      return [component.to_form({
        like_url: like_url,
        gplus_url: gplus_url
      })];
    })
  };
  return new jsdk.Form(config, {}, locale);
};

function getReducerPrivacyForm(locale, privacy_required) {
  const config = {
    attrs: {
      id: 'privacy_form'
    },
    rows: [
      [{
          type: 'checkbox',
          id: 'is_privacy_checked',
          schema: {
            type: 'boolean',
            any: [true]
          }
        },
        '<div class="large-text-left">' + micromd(privacy_required) + '</div>'
      ]
    ]
  };
  return new jsdk.Form(config, {}, locale);
}

Reducer.prototype.isPrivacyRequired = function () {
  return this.privacy_type === 'required';
};

Reducer.prototype.to_widget = function (sandbox) {

  const {
    locale,
    like_url,
    gplus_url,
    context,
    default_privacy,
  } = sandbox;

  const bundle = get_bundle(locale).reducer;
  const form = this.getReducerForm(locale, like_url, gplus_url);
  const privacyForm = this.isPrivacyRequired() ? getReducerPrivacyForm(locale, bundle.privacy_required) : null;
  const timeout = this.timeout;

  const html = template.of('reducer_content')({
    reducer: form.to_html(context),
    is_skippable: this.is_skippable,
    privacy_type: this.privacy_type,
    privacy: String(this.get_privacy(default_privacy)),
    is_privacy_open: this.is_privacy_open,
    do_skip: bundle.do_skip,
    do_reduce: bundle.do_reduce,
    required_privacy_form: privacyForm ? privacyForm.to_html() : '', // se è required
    standard_privacy_disclaimer: this.privacy_type === 'standard' ? micromd(bundle.privacy) : '', // se è standard
    styleBtnColor: sandbox.styleBtnColor
  });

  let timeoutID = null;

  function start() {

    form.start();

    if (privacyForm) {
      privacyForm.start();
    }

    $('#reducer_content')
      .on('click', 'a[href=go_privacy]', function (evt) {
        evt.preventDefault();
        $('#privacy').toggle();
      })
      .on('click', '#do_reduce', function () {
        // gestione timeout del bottone riduci
        if (!$('#do_reduce').hasClass('disabled')) {
          var value = form.value(context);
          if (value) {
            if (privacyForm) {
              var privacy_value = privacyForm.value();
              if (privacy_value) {
                sandbox.do_reduce(value);
              }
            }
            else {
              sandbox.do_reduce(value);
            }
          }
        }
      })
      .on('click', '#do_skip', function () {
        const cbk = (b) => {
          if (b) {
            sandbox.do_skip();
          }
          else {
            ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
          }
        };
        ReactDOM.render(<Confirm callback={cbk} locale={locale} width='600' title={bundle.do_skip}><Alert type="warning">{bundle.confirm_skip}</Alert></Confirm>, document.getElementById('modal-container'));
      });

    // gestione timeout del bottone riduci
    if (timeout) {
      $('#do_reduce').addClass('disabled');
      timeoutID = setTimeout(function() {
        $('#do_reduce').removeClass('disabled');
      }, timeout * 1000);
    }
  }

  function stop() {

    form.stop();

    if (privacyForm) {
      privacyForm.stop();
    }

    $('#reducer_content').off();

    // gestione timeout del bottone riduci
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  }

  return new jsdk.Widget(html, start, stop);
};

Reducer.prototype.getReducerBehaviour = function (lattice_id: UUID, form_value: t.Object) {
  var feedbacks = [];

  function getFeedback([id, value]) {
    return new Feedback({id, value});
  }

  for (var k in form_value) {
    var answer = form_value[k];
    if (t.Array.is(answer)) {
      feedbacks = feedbacks.concat(answer.map(getFeedback));
    }
    else {
      feedbacks.push(new Feedback({id: k, value: answer}));
    }
  }

  return new Behaviour({
    lattice_id,
    reducer_id: this.id,
    value: feedbacks
  });
};

Reducer.prototype.getSkipBehaviour = function (lattice_id: UUID) {
  return new Behaviour({
    lattice_id,
    reducer_id: this.id,
    value: null
  });
};

export default Reducer;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Reducer.js
 **/